export const isTariffsEnabled = true;



// WEBPACK FOOTER //
// ./src/components/Profile/helpers.js